import React from 'react';

const DownloadCTA: React.FC = () => {
  return (
    <div className="py-12 px-6">
      <div className="max-w-4xl mx-auto p-6 md:p-10 text-center">
        <h2 className="text-white text-2xl md:text-3xl font-bold mb-5 drop-shadow-md">
          Find the right words, right when you need them
        </h2>
        <p className="text-white text-base md:text-lg mb-8 max-w-2xl mx-auto opacity-90">
          Quote Vibes is your pocket-sized source of daily inspiration and reflection. Whether you're looking for a boost of confidence, a moment of peace, or something that simply gets you—we've got a quote for that.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a 
            href="https://apps.apple.com/us/app/quote-vibes-daily/id6744850119"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-90 transition-opacity duration-300"
          >
            <img 
              src="/app-store.svg.webp" 
              alt="Download on App Store" 
              className="h-14 md:h-16"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadCTA; 